export const repUsers = (state, rootState) => {
	return state.repUsers;
}

export const customerUsers = (state, rootState) => {
	return state.customerUsers;
}

export const specificUsers = (state, rootState) => {
	return state.specificUsers;
}

export const publicUsers = (state, rootState) => {
	return state.publicUsers;
}

export const vendorUsers = (state, rootState) => {
	return state.vendorUsers;
}

export const objUserSettings = (state, rootState) => {
    return state.objUserSettings;
}

export const objUserNotifications = (state, rootState) => {
	return state.objUserNotifications;
}

export const objUserPricelists = (state, payload) => {
    return state.objUserPricelists;
}

export const objUserStatus = (state, payload) => {
	return state.objUserStatus;
}

export const objUserCompanies = (state, payload) => {
	return state.objUserCompanies;
}

export const currentUserCompany = (state, payload) => {
	return state.currentUserCompany;
}

export const currentCompany = (state, payload) => {
	return state.currentCompany;
}

export const currentUser = (state, payload) => {
	return state.currentUser;
}

export const currentRegions = (state, payload) => {
	return state.currentRegions;
}

export const userCustomers = (state, payload) => {
	return state.userCustomers;
}

export const userCompanies = (state, payload) => {
	return state.userCompanies;
}

export const userReps = (state, payload) => {
	return state.userReps;
}

export const overrideSettings = (state, payload) => {
	return state.overrideSettings;
}

export const userLinks = (state, payload) => {
	return state.userLinks;
}

export const userAddRoles = (state, payload) => {
	return state.userAddRoles;
}

export const userAddCompanies = (state, payload) => {
	return state.userAddCompanies;
}

export const objUserEdit = (state, payload) => {
	return state.objUserEdit;
}

export const objCompanyEdit = (state, payload) => {
	return state.objCompanyEdit;
}

export const userRegions = (state, payload) => {
	return state.userRegions;
}

export const repUserSearch = (state, payload) => {
	return state.repUserSearch;
}

export const customerUserSearch = (state, payload) => {
	return state.customerUserSearch;
}

export const specificUserSearch = (state, payload) => {
	return state.specificUserSearch;
}

export const publicUserSearch = (state, payload) => {
	return state.publicUserSearch;
}

export const vendorUserSearch = (state, payload) => {
	return state.vendorUserSearch;
}

export const userVendors = (state, payload) => {
  return state.userVendors;
}

export const repsLoaded = (state, payload) => {
	return state.repsLoaded;
}

export const customersLoaded = (state, payload) => {
	return state.customersLoaded;
}

export const publicLoaded = (state, payload) => {
	return state.publicLoaded;
}

export const specifierLoaded = (state, payload) => {
	return state.specifierLoaded;
}

export const vendorLoaded = (state, payload) => {
	return state.vendorLoaded;
}

export const userLoading = (state, payload) => {
  return state.userLoading;
}

export const leadUserSelected = (state, payload) => {
  return state.leadUserSelected;
}

export const newLeadUsers = (state, payload) => {
  return state.newLeadUsers;
}

export const quoteNo = (state, payload) => {
  return state.quoteNo;
}

export const publicTotalPages = (state, payload) => {
  return state.publicTotatlPages;
}

export const userAvatar = (state, payload) => {
  return state.userAvatar;
}

export const repsShortList = (state, payload) => {
  return state.repsShortList;
}